import {
  DEFAULT_EXECUTION_PROFILE,
  normalizeExecutionProfile,
  messageIdentityKeyForExecutionProfile,
} from 'flare-chat-core/contracts/modes/execution-profile';

const PROFILE_PREFERENCES = Object.freeze({ default: 'auto', expert: 'workflow_preferred' });

/** Delegate protocol normalization to FLARE; selection never activates a procurement stage. */
export const resolveComposerExecutionProfile = (modeKey) => (
  normalizeExecutionProfile(modeKey) || DEFAULT_EXECUTION_PROFILE
);
export const resolveComposerModePreference = (modeKey) => (
  PROFILE_PREFERENCES[resolveComposerExecutionProfile(modeKey)]
);
export const resolveComposerModeKey = (modeKey) => (
  messageIdentityKeyForExecutionProfile(resolveComposerExecutionProfile(modeKey))
);
export const buildComposerExecutionOptions = (modeKey) => ({
  modeKey: resolveComposerModeKey(modeKey),
  executionProfile: resolveComposerExecutionProfile(modeKey),
  modePreference: resolveComposerModePreference(modeKey),
});
